export const siteConfig = {
  name: '爱漫画',
  title: '爱漫画 | 非常爱漫画免费在线看全集 | 好看的漫画大全',
  description: '非常爱漫画提供免费漫画全集在线看，支持下拉式阅读，海量好看的国漫日漫韩漫免费追更，爱漫画平台免费漫画大全随时畅读。',
  keywords: '非常爱漫画, 非常爱漫画免费, 非常爱漫画在线看, 非常爱漫画全集, 爱漫画, 免费漫画, 漫画大全, 在线漫画, 下拉式漫画, 好看的漫画',
  url: 'https://www.aimanhua.com',
  ogImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20colorful%20manga%20comic%20reading%20website%20banner%20with%20popular%20anime%20characters%20in%20dynamic%20poses%2C%20Japanese%20manga%20style%20artwork%20with%20bright%20colors%2C%20action%20scenes%2C%20comic%20speech%20bubbles%2C%20clean%20composition%20on%20warm%20gradient%20background%2C%20professional%20web%20banner%20design&width=1200&height=630&seq=og-image&orientation=landscape',
};

export const categories = [
  { id: 'rexue', name: '热血', slug: 'rexue', icon: 'ri-fire-line', description: '热血战斗、激情澎湃的漫画作品' },
  { id: 'lianai', name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜浪漫、心动不已的恋爱故事' },
  { id: 'xuanhuan', name: '玄幻', slug: 'xuanhuan', icon: 'ri-magic-line', description: '奇幻世界、修炼冒险的玄幻佳作' },
  { id: 'gaoxiao', name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '轻松幽默、笑料百出的搞笑漫画' },
  { id: 'xuanyi', name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '烧脑推理、扣人心弦的悬疑故事' },
  { id: 'dushi', name: '都市', slug: 'dushi', icon: 'ri-building-line', description: '都市生活、职场情感的现代故事' },
  { id: 'kehuan', name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', description: '未来科技、星际探索的科幻世界' },
  { id: 'hanman', name: '韩漫', slug: 'hanman', icon: 'ri-kakao-talk-line', description: '精美画风、独特剧情的韩国漫画' },
];

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updateDate: string;
  chapters: ComicChapter[];
}

export const featuredComics: Comic[] = [
  {
    id: 'comic-001',
    title: '星辰变',
    author: '我吃西红柿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20art%20featuring%20a%20young%20warrior%20in%20flowing%20robes%20wielding%20a%20glowing%20sword%20against%20a%20starry%20night%20sky%20with%20celestial%20phenomena%2C%20epic%20xianxia%20style%2C%20vibrant%20colors%2C%20dramatic%20lighting%2C%20clean%20composition%20perfect%20for%20comic%20cover&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    description: '一名普通少年，偶然获得一枚神秘流星，从此踏上修仙之路。浩瀚星空，万千世界，且看他如何一步步走向巅峰，成为星辰之主！',
    category: 'xuanhuan',
    tags: ['修仙', '热血', '冒险'],
    rating: 9.6,
    views: 1280000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-001-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
  },
  {
    id: 'comic-002',
    title: '斗破苍穹',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20young%20martial%20artist%20with%20flame%20energy%20surrounding%20his%20body%20in%20a%20dynamic%20battle%20pose%2C%20Chinese%20manhua%20style%20artwork%2C%20intense%20orange%20and%20red%20color%20palette%2C%20dramatic%20composition%20with%20fire%20effects%2C%20clean%20cover%20design&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然变成了废人。就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现，一扇全新的大门就此开启！',
    category: 'xuanhuan',
    tags: ['玄幻', '热血', '战斗'],
    rating: 9.8,
    views: 2560000,
    status: '已完结',
    updateDate: '2026-07-28',
    chapters: Array.from({ length: 400 }, (_, i) => ({
      id: `ch-002-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-07-28',
    })),
  },
  {
    id: 'comic-003',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20supernatural%20manhua%20cover%20with%20a%20mysterious%20young%20man%20surrounded%20by%20glowing%20energy%20spirits%20and%20martial%20arts%20elements%2C%20traditional%20Chinese%20aesthetics%20mixed%20with%20modern%20urban%20setting%2C%20cool%20color%20tones%2C%20clean%20composition&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的到来，少年张楚岚的平静校园生活被彻底打破。在这个异人世界之中，他将何去何从？',
    category: 'dushi',
    tags: ['都市', '异能', '冒险'],
    rating: 9.5,
    views: 1890000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 580 }, (_, i) => ({
      id: `ch-003-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-03',
    })),
  },
  {
    id: 'comic-004',
    title: '全职高手',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20esports%20manhua%20cover%20showing%20a%20cool%20gamer%20character%20in%20a%20virtual%20reality%20game%20world%20with%20glowing%20keyboard%20and%20digital%20effects%2C%20futuristic%20gaming%20aesthetic%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20cover%20art&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。离开职业圈的他寄身于一家网吧成了一个小小的网管，但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏。',
    category: 'dushi',
    tags: ['游戏', '竞技', '热血'],
    rating: 9.7,
    views: 2100000,
    status: '已完结',
    updateDate: '2026-06-15',
    chapters: Array.from({ length: 320 }, (_, i) => ({
      id: `ch-004-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-06-15',
    })),
  },
  {
    id: 'comic-005',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20romance%20manhua%20cover%20featuring%20a%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20and%20traditional%20red%20dress%20surrounded%20by%20cherry%20blossom%20petals%2C%20romantic%20fantasy%20setting%2C%20soft%20pink%20and%20gold%20colors%2C%20clean%20composition&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。人死了，妖还活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人，回忆起前世的爱。',
    category: 'lianai',
    tags: ['恋爱', '奇幻', '古风'],
    rating: 9.4,
    views: 1670000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 420 }, (_, i) => ({
      id: `ch-005-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-02',
    })),
  },
  {
    id: 'comic-006',
    title: '镇魂街',
    author: '许辰',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20supernatural%20action%20manhua%20cover%20with%20a%20young%20man%20summoning%20a%20massive%20guardian%20spirit%20warrior%20behind%20him%2C%20Chinese%20mythological%20elements%2C%20dark%20and%20mysterious%20atmosphere%2C%20dramatic%20composition%20with%20dual%20characters%2C%20clean%20cover%20art&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    description: '普通的应届大学毕业生夏铃在求职之际，误打误撞进入了一个奇异的世界——镇魂街。在这个人灵共存的世界里，她将遇到怎样的冒险？',
    category: 'rexue',
    tags: ['热血', '奇幻', '冒险'],
    rating: 9.3,
    views: 1450000,
    status: '连载中',
    updateDate: '2026-07-30',
    chapters: Array.from({ length: 350 }, (_, i) => ({
      id: `ch-006-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-07-30',
    })),
  },
  {
    id: 'comic-007',
    title: '非人哉',
    author: '一汪空气',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20cute%20Chinese%20comedy%20manhua%20cover%20with%20colorful%20mythological%20creatures%20living%20modern%20city%20life%2C%20playful%20cartoon%20style%2C%20bright%20and%20cheerful%20colors%2C%20comedy%20slice%20of%20life%20vibe%2C%20clean%20cover%20design&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    description: '什么？建国以后妖怪不能成精？那以前的妖怪怎么办？好吧，它们如今依旧混迹在人类之中！九尾狐、白龙马、哪吒……各路神仙妖怪在现代社会的爆笑日常！',
    category: 'gaoxiao',
    tags: ['搞笑', '日常', '妖怪'],
    rating: 9.2,
    views: 980000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 620 }, (_, i) => ({
      id: `ch-007-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
  },
  {
    id: 'comic-008',
    title: '端脑',
    author: '壁水羽',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20suspense%20thriller%20manhua%20cover%20with%20a%20mysterious%20brain%20and%20puzzle%20elements%2C%20dark%20psychological%20theme%2C%20geometric%20patterns%20and%20maze%20designs%2C%20cold%20blue%20and%20black%20color%20scheme%2C%20clean%20and%20intriguing%20composition&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    description: '当你的女友突然失踪，所有的线索都指向一个神秘的虚拟游戏——端脑。为了寻找真相，夏驰毅然进入了这个充满谜题与危险的游戏世界。',
    category: 'xuanyi',
    tags: ['悬疑', '推理', '科幻'],
    rating: 9.1,
    views: 760000,
    status: '已完结',
    updateDate: '2026-05-20',
    chapters: Array.from({ length: 230 }, (_, i) => ({
      id: `ch-008-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-05-20',
    })),
  },
  {
    id: 'comic-009',
    title: '星海镖师',
    author: '颜开',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20sci-fi%20manhua%20cover%20with%20a%20space%20bounty%20hunter%20character%20in%20futuristic%20armor%20against%20a%20backdrop%20of%20stars%20and%20spaceships%2C%20cyberpunk%20aesthetic%2C%20neon%20colors%2C%20dynamic%20action%20pose%2C%20clean%20cover%20art&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    description: '在遥远的未来，人类已经进入星际时代。镖师，这个古老的职业在星际时代焕发出全新的光彩。少年唐小镖怀揣着成为最强镖师的梦想，踏上了冒险之旅。',
    category: 'kehuan',
    tags: ['科幻', '冒险', '热血'],
    rating: 9.0,
    views: 890000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 280 }, (_, i) => ({
      id: `ch-009-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-01',
    })),
  },
  {
    id: 'comic-010',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20cover%20showing%20a%20gorgeous%20girl%20with%20perfect%20makeup%20transformation%2C%20before%20and%20after%20concept%2C%20romantic%20comedy%20vibe%2C%20soft%20pastel%20pink%20and%20peach%20colors%2C%20clean%20and%20elegant%20composition&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    description: '因为外表而被嘲笑的女孩，通过化妆逆袭成为校园女神。然而，完美的外表下，真实的她又将何去何从？一段关于自信与爱情的青春故事就此展开。',
    category: 'hanman',
    tags: ['韩漫', '恋爱', '校园'],
    rating: 9.5,
    views: 3200000,
    status: '已完结',
    updateDate: '2026-04-10',
    chapters: Array.from({ length: 180 }, (_, i) => ({
      id: `ch-010-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-04-10',
    })),
  },
  {
    id: 'comic-011',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20with%20a%20contrast%20between%20an%20unattractive%20high%20school%20student%20and%20his%20handsome%20alter%20ego%2C%20social%20commentary%20theme%2C%20dramatic%20lighting%2C%20urban%20school%20setting%2C%20clean%20webtoon%20style%20cover&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    description: '因为长相丑陋而备受欺凌的朴亨锡，意外发现自己拥有了另一具完美的身体。白天是帅气校草，夜晚变回原样。在这看脸的时代，他该如何找到真正的自己？',
    category: 'hanman',
    tags: ['韩漫', '校园', '热血'],
    rating: 9.6,
    views: 4500000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 450 }, (_, i) => ({
      id: `ch-011-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
  },
  {
    id: 'comic-012',
    title: '我家大师兄脑子有坑',
    author: '凌宇沫',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20xianxia%20manhua%20cover%20with%20a%20funny%20and%20handsome%20cultivator%20character%20making%20a%20silly%20expression%2C%20traditional%20Chinese%20cultivation%20setting%20with%20humorous%20twist%2C%20bright%20and%20lively%20colors%2C%20clean%20and%20playful%20composition&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    description: '穿越到修仙世界成为大师兄，本以为可以过上左拥右抱的幸福生活，却发现不仅师弟师妹个个是奇葩，连自己脑子好像也不太对劲？爆笑修仙日常就此展开！',
    category: 'gaoxiao',
    tags: ['搞笑', '修仙', '穿越'],
    rating: 9.3,
    views: 1350000,
    status: '已完结',
    updateDate: '2026-06-30',
    chapters: Array.from({ length: 200 }, (_, i) => ({
      id: `ch-012-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-06-30',
    })),
  },
];

export const allComics: Comic[] = featuredComics;

export const latestUpdates: Comic[] = [...featuredComics].sort(() => Math.random() - 0.5);

export const popularComics: Comic[] = [...featuredComics].sort((a, b) => b.views - a.views).slice(0, 6);

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return allComics.filter((comic) => comic.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return allComics.find((comic) => comic.id === id);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find((cat) => cat.slug === slug);
};